module.exports = __webpack_public_path__ + "static/before-5-66313932f980a063b67a2d372c8916c3.png";